const config = {
  ENV: "dev"
};
export default config;
